import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-rings-loader',
  templateUrl: './rings-loader.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './rings-loader.component.scss'
})
export class RingsLoaderComponent {

}
